import React from 'react'
import PropTypes from 'prop-types'
import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Title, Tooltip} from "chart.js"
import {Bar} from "react-chartjs-2"


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip)

const options = {
    animation:false,
    maintainAspectRatio: false,
    responsive: true,
    datasets: {
        bar: {
            barPercentage: 0.4,
            categoryPercentage: 1,
        },
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
            ticks: {
                callback: (value) => value.toLocaleString("de-DE", {
                    minimumFractionDigits: 0,
                }) + " EUR"
            },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltip: {
            displayColors: false,
            bodyAlign: "center",
            callbacks: {
                title: () => "",
                label: (data) => [
                    data.dataset.label + ":",
                    data.raw.toLocaleString("de-DE", {
                        minimumFractionDigits: 2,
                    }) + " EUR"
                ],
            },
        },
    },
}

const TpUiStackedVerlaufBarChart = ({data}) => <Bar type="bar" options={options} data={data}/>

TpUiStackedVerlaufBarChart.propTypes = {
    data: PropTypes.exact({
        labels: PropTypes.arrayOf(PropTypes.string),
        datasets: PropTypes.arrayOf(
            PropTypes.exact({
                label: PropTypes.string,
                data: PropTypes.arrayOf(PropTypes.string),
                backgroundColor: PropTypes.string,
            }),
        ),
    }),
}

export default TpUiStackedVerlaufBarChart
